import { loadFont as loadSans } from '@remotion/google-fonts/PlusJakartaSans';
import { loadFont as loadSerif } from '@remotion/google-fonts/InstrumentSerif';
import { loadFont as loadMono } from '@remotion/google-fonts/SpaceMono';
import type { VideoTheme } from './types';

const sans = loadSans('normal', { weights: ['400', '500', '600', '700', '800'], subsets: ['latin'] });
const serif = loadSerif('normal', { weights: ['400'], subsets: ['latin'] });
loadSerif('italic', { weights: ['400'], subsets: ['latin'] });
const mono = loadMono('normal', { weights: ['400', '700'], subsets: ['latin'] });

export const FONTS = { sans: sans.fontFamily, serif: serif.fontFamily, mono: mono.fontFamily };

export const headingFamily = (t: VideoTheme) => (t.headingFont === 'serif' ? FONTS.serif : FONTS.sans);
export const headingWeight = (t: VideoTheme) => (t.headingFont === 'serif' ? 400 : 800);

function rgb(hex: string): [number, number, number] {
    const h = hex.replace('#', '');
    const n = parseInt(h.length === 3 ? h.split('').map((c) => c + c).join('') : h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function luminance(hex: string): number {
    const [r, g, b] = rgb(hex).map((c) => {
        const v = c / 255;
        return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Readable text color on top of `bg`. */
export const onColor = (bg: string, ink = '#111111') => (luminance(bg) > 0.45 ? ink : '#FFFFFF');

export const alpha = (hex: string, a: number) => {
    const [r, g, b] = rgb(hex);
    return `rgba(${r},${g},${b},${a})`;
};

export const isDark = (hex: string) => luminance(hex) < 0.2;
